var map = {
	"./bmstu.png": "60bb",
	"./email.png": "9afb",
	"./github.png": "359c",
	"./hh.png": "56e1",
	"./k6.png": "c194",
	"./logo.png": "cf05",
	"./mailru.png": "ef53",
	"./ozon.png": "df98",
	"./profile.jpg": "3a19",
	"./telegram.png": "c2ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";